import React, { useState } from "react";
import { SwatchIcon, DevicePhoneMobileIcon } from "@heroicons/react/24/outline";
import Breadcrumb from "../../comp/Breadcrumb"; // Breadcrumb 컴포넌트 임포트

const Mo0101 = () => {
  // 앱 리스트
  const [apkList, setApkList] = useState([
    { name: "안드로이드 앱 v1.0", url: "https://nhdongin.com//files/app-v1.0.apk" },
  ]);
  const [iosList, setIosList] = useState([
    { name: "아이폰 앱 v1.0", url: "https://example.com/app-v1.0.ipa" },
  ]);

  const breadcrumbItem = [{ name: "설정" }, { name: "농협동인회 앱 다운로드" }];

  // 다운로드 핸들러
  const handleDownload = (url: string, filename: string) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 공통 앱 카드
  const appCard = (
    app: { name: string; url: string },
    icon: JSX.Element,
    bgColor: string
  ) => (
    <div
      key={app.name}
      className={`bg-white rounded-xl shadow-md p-6 flex flex-col items-center space-y-4 hover:shadow-lg transition-shadow ${bgColor}`}
    >
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-gray-100">
        {icon}
      </div>
      <div className="text-lg font-semibold text-gray-800">{app.name}</div>
      <button
        type="button"
        onClick={() => handleDownload(app.url, `${app.name}`)}
        className="bg-gradient-to-r from-green-400 to-green-600 text-white px-6 py-2 rounded-lg shadow-md hover:from-green-500 hover:to-green-700 transition-all"
      >
        다운로드
      </button>
    </div>
  );

  // 안드로이드 섹션
  const androidSection = () => (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {apkList.map((apk) =>
          appCard(
            apk,
            <SwatchIcon className="w-8 h-8 text-green-500" />,
            "hover:bg-green-50"
          )
        )}
      </div>
      
      {/* 설치 안내문 수정 */}
      <div className="bg-white rounded-xl p-6 shadow-md">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">설치 안내</h3>
        <div className="space-y-3 text-gray-600">
          <p className="flex items-center">
            <span className="font-semibold mr-2">1.</span>
            상단의 '다운로드' 버튼을 클릭하여 APK 파일을 다운로드합니다.
          </p>
          <p className="flex items-center">
            <span className="font-semibold mr-2">2.</span>
            다운로드된 파일 찾기:
          </p>
          <ul className="list-disc ml-8 space-y-2">
            <li>'내 파일' 또는 '파일 관리자' 앱을 실행</li>
            <li>'다운로드' 폴더로 이동 (보통 내부저장소 → Download)</li>
            <li>'app-v1.0.apk' 파일을 찾아 클릭</li>
          </ul>
          <p className="flex items-center">
            <span className="font-semibold mr-2">3.</span>
            '알 수 없는 출처' 설치 경고가 표시될 경우:
          </p>
          <ul className="list-disc ml-8 space-y-2">
            <li>설정 → 보안 메뉴로 이동</li>
            <li>'알 수 없는 출처' 또는 '출처를 알 수 없는 앱 설치' 옵션을 활성화</li>
            <li>다시 APK 파일을 클릭하여 설치 진행</li>
          </ul>
          <p className="flex items-center">
            <span className="font-semibold mr-2">4.</span>
            설치가 완료되면 '열기' 버튼을 눌러 앱을 실행합니다.
          </p>
          <div className="mt-4 p-4 bg-yellow-50 rounded-lg">
            <p className="text-yellow-800 font-semibold">주의사항</p>
            <ul className="list-disc ml-6 mt-2 text-yellow-700">
              <li>설치 전 충분한 저장 공간이 있는지 확인해주세요.</li>
              <li>안드로이드 6.0 이상의 버전이 필요합니다.</li>
              <li>설치 후 정상적으로 실행되지 않을 경우, 앱을 삭제 후 재설치해주세요.</li>
              <li>다운로드한 파일이 보이지 않으면 휴대폰을 재시작하거나 다시 다운로드해주세요.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );

  // 아이폰 섹션
  const iosSection = () => (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {iosList.map((ios) =>
        appCard(
          ios,
          <DevicePhoneMobileIcon className="w-8 h-8 text-blue-500" />,
          "hover:bg-blue-50"
        )
      )}
    </div>
  );

  return (
    <div className="space-y-6 p-6 bg-gray-100 min-h-screen">
      {/* 상단 영역 */}
      <div className="space-y-2">
        <Breadcrumb items={breadcrumbItem} />
      </div>

      {/* 페이지 제목 */}
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-800">
          농협동인회 모바일 앱 다운로드
        </h1>
        <p className="text-gray-600 mt-2">
          농협동인회 전용 모바일 앱을 아래에서 다운로드하세요.
        </p>
      </div>

      {/* 안드로이드 다운로드 */}
      <div>
        <h2 className="text-xl font-bold text-gray-700 mb-4">
          안드로이드 앱
        </h2>
        {androidSection()}
      </div>

      {/* 아이폰 다운로드 */}
      {/* <div>
        <h2 className="text-xl font-bold text-gray-700 mb-4">아이폰 앱</h2>
        {iosSection()}
      </div> */}
    </div>
  );
};

export default Mo0101;
